document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".article__content img");

  images.forEach(img => {
    // Skip the featured image (already optimized)
    if (img.classList.contains('article-featured-img')) return;

    // Add lazy loading if not present
    if (!img.hasAttribute("loading")) {
      img.setAttribute("loading", "lazy");
    }

    // Add width and height if missing
    if (!img.hasAttribute("width") || !img.hasAttribute("height")) {
      const tmp = new Image();
      tmp.src = img.src;
      tmp.onload = () => {
        img.width = tmp.naturalWidth;
        img.height = tmp.naturalHeight;
      };
    }
  });
});
